import axios from 'axios';

export const CancelToken = axios.CancelToken;
export const source = CancelToken.source();
export const isCancel = (error: {message: string}) => axios.isCancel(error);
